import { useSelector } from "react-redux";

import { selectAuth, selectMerchant } from "@redux";
import { useEffect, useState } from "react";
import styled from "styled-components";

import { ArrowLeftColor } from "@components";
import { RenderMeta } from "@utils";
import { t } from "i18next";
import BenefitBoxes from "src/Components/memberCard/BenefitBoxes";
import Card from "src/Components/memberCard/Card";
import MemberTier from "src/Components/memberCard/MemberTier";

export const PageMemberCard = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    //variable
    const merchantRedux = useSelector(selectMerchant);
    const [merchant, setMerchant] = useState<any>();
    const { themes } = useSelector(selectMerchant);

    useEffect(() => {
        if (merchantRedux) setMerchant(merchantRedux);
    }, [merchantRedux]);

    return (
        <StyledMemberCard
            themeColor={themes?.themeColor!}
            cardBG={merchant?.memberShipTiers?.[currentIndex]?.benefitBackCardImage || ""}
        >
            <RenderMeta title={t("meta.membercard_page")} />
            <WrapperMainDetailCard>
                <div className="back-arrow">
                    <ArrowLeftColor onClick={() => history.back()} color={themes?.themeColor} />
                    {/* <span>{t("page.back")}</span> */}
                </div>
                <Card {...{ merchant, userInfo, currentIndex, setCurrentIndex }} />
            </WrapperMainDetailCard>

            <WrapperDetailCard>
                <MemberTier {...{ merchant, currentIndex }} />
                <BenefitBoxes {...{ merchant, currentIndex }} />
            </WrapperDetailCard>
        </StyledMemberCard>
    );
};

//#region Styled-Components

const StyledMemberCard = styled.div<{ themeColor: string; cardBG: string }>`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: linear-gradient(
        106.8deg,
        rgba(152, 140, 117, 1) 12%,
        rgba(82, 88, 91, 1) 41.6%,
        rgba(151, 113, 52, 1) 87.8%
    );
    background-color: #ddd;
    background-image: url(${(p) => p.cardBG});
    background-size: cover;
    .back-arrow {
        display: flex;
        padding-left: 16px;
        align-items: center;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    .content-layout {
        height: auto;
        min-height: 80dvh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .content {
            background: transparent !important;
        }
        .btn-redeem {
            color: #fff;
            background-color: #336c51;
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            border-bottom: 1px solid #f0f0f0;
            margin-bottom: 20px;
            margin-top: -100px;
            padding-bottom: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        background-color: #f8f4ec;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            margin-bottom: 50px;
            .topic-detail {
                text-align: center;
                color: #336c51;
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
            }
        }
    }
    .content {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            padding: 10px;
        }
        .interception {
            width: 100%;
            border-bottom: 7px dotted ${(p) => p.theme.colors.cutter};
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                background: ${(p) => p.theme.colors.cutter};
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #f8eff0;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            // background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .code-qr {
                font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                color: #000;
                text-align: center;
            }
            .redeemed-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .pending-product {
                text-align: center;
                font-size: 12px;
                color: #ed773a;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .used-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #9b9b9b;
            }
        }
    }
`;

const WrapperMainDetailCard = styled.div`
    padding: 30px 0 0;

    .btn-back {
        padding: 0 16px;
        margin-bottom: 20px;
        img {
            max-width: 24px;
        }
    }
    .swiper-pagination {
        bottom: 15px;
        .swiper-pagination-bullet {
            background-color: #fff;
            margin: 0;
            border-radius: 0;
            width: 16px;
            height: 3px;
        }
    }
    .swiper-container {
        overflow: unset;
    }
    .swiper-wrapper {
        div {
            div {
                div {
                    overflow: unset !important;
                }
            }
        }
    }
    .layout-main-detail-card {
        padding: 0px 8px;
        margin: 0 8px 50px 4px;
        transition: 0.5s all;
        img {
            width: 100%;
        }
        &:hover {
            transform: scale(1.015);
            filter: brightness(1.1);
            .layout-card-membercard {
                &::before {
                    filter: brightness(0.5);
                    top: 50px;
                    left: 300px;
                }
            }
        }
        .layout-card-membercard {
            position: relative;
            border-radius: 16px;
            overflow: hidden !important;
            height: 210px;
            // &::before {
            //     position: fixed;
            //     content: "";
            //     box-shadow: 0 0 10px 10px #ffffff08;
            //     top: -10%;
            //     left: -100%;
            //     transform: rotate(-45deg);
            //     height: 60rem;
            //     transition: 0.7s all;
            // }
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .current-card-membercard {
                position: absolute;
                top: 0;
                left: 0;
                padding: 4px 12px;
                background-color: rgba(0, 0, 0, 0.3);
                color: #fff;
                border-bottom-right-radius: 16px;
                border-top-left-radius: 16px;
                font-size: 11px;
            }
            .text-card-membercard {
                position: absolute;
                top: 34px;
                left: 12px;
                .tier-card-membercard {
                    font-size: 20px;
                    font-weight: 600;
                    margin-bottom: 5px;
                }
                .valid-card-membercard {
                    font-size: 11px;
                    color: #525257;
                    margin-bottom: 15px;
                }
                .point-card-membercard {
                    font-size: 16px;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    span {
                        margin-left: 5px;
                        display: flex;
                        margin-top: 3px;
                        img {
                            width: 16px;
                        }
                    }
                }
                .detail-card-membercard {
                    font-size: 10px;
                }
            }
        }
    }
    .layout-dot-detail-card {
        margin-bottom: 5px;
        text-align: center;
        img {
            max-width: 100%;
        }
    }
`;

const WrapperDetailCard = styled.div`
    background-color: #fff;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
    padding: 24px 16px 16px 16px;

    .topic-detail-card {
        position: absolute;
        font-size: 16px;
        line-height: 20px;
        color: #000;
        font-weight: 600;
        margin-bottom: 14px;
        span {
            margin-left: 10px;
        }
    }
    .layout-detail-card {
        position: relative;
        margin-bottom: 16px;
        padding: 30px 16px;
        border-radius: 14px;
        padding-right: 120px;
        background-color: #f8f4ec;
        min-height: 103px;
        .img-member-detail {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            a {
                img {
                    max-width: 80px;
                    width: 100%;
                }
            }
        }
        .topic-member-detail {
            font-size: 16px;
            line-height: 20px;
            font-weight: 600;
            color: #000;
            margin-bottom: 10px;
        }
        .desc-member-detail {
            font-size: 11px;
            line-height: 13px;
            color: #525257;
        }
    }
`;

//#endregion
